module.exports = {"id":"201066","name":"Dominik Kaiser","rating":"72","photo":"./data/images/photos/4/201066.png","club":{"name":"RB Leipzig","logo":"./data/images/clubs/RBLeipzig.png"},"positions":["MOC","MC","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DominikKaiser0.json
// module id = 1135
// module chunks = 0